export default (state = {}, action) => {
	const switchObj = {
		imagesExist: () => {
			return {
				...state,
				[action.payload.contactID]: {
					...(state[action.payload.contactID] || {}),
					...action.payload.imageURLs,
				},
			}
		},
	}

	return switchObj?.[action?.type] ? switchObj[action?.type]() : state
}
